import { FC } from 'react';
import { Select } from 'antd';
import BaseItem, { BaseItemProps } from './BaseItem';
import { SelectValue } from 'antd/lib/select';

interface SelectOptionProps {
  v: string | number;
  t: string | React.ReactNode;
  hide?: boolean;
}

interface SelectProps extends BaseItemProps {
  options: SelectOptionProps[];
  onChange?: (value: SelectValue, option: any) => void;
}

const SelectItem: FC<SelectProps> = (props) => {
  const { options, onChange, ...rest } = props;
  return (
    <BaseItem {...rest}>
      <Select onChange={onChange}>
        {options
          .filter((item) => !item.hide)
          .map((item) => (
            <Select.Option value={item.v} key={item.v}>
              {item.t}
            </Select.Option>
          ))}
      </Select>
    </BaseItem>
  );
};

export default SelectItem;
